import { formatValue } from '@utils/number';

type TShowAmountProps = {
  value: number;
  currency: string;
  maxDigits?: number;
  hideCurrency?: boolean;
};

export const showAmount = ({
  value,
  currency,
  maxDigits = 2,
  hideCurrency = false,
}: TShowAmountProps): string => {
  return `${formatValue(value, currency, maxDigits)} ${hideCurrency ? '' : currency}`;
};
